export const LOCATION_FIELDS = [
  { key: 'availability_state', label: 'Availability', type: 'select', options: ['Available', 'Blocked', 'Temporarily Unavailable', 'Reserved', 'Requires Validation'] },
  { key: 'active_state', label: 'Active', type: 'select', options: ['Active', 'Inactive', 'Phasing Out'] },
  { key: 'governance_status', label: 'Governance', type: 'select', options: ['READY FOR ERNIE APPROVAL', 'ERNIE DECISION REQUIRED', 'GOVERNANCE / DATA GAP'] },
  { key: 'location_group', label: 'Group', type: 'select', optionsFrom: 'locationGroups' },
  { key: 'capacity_profile_id', label: 'Capacity profile', type: 'select', optionsFrom: 'capacityProfiles', allowBlank: true },
  { key: 'manual_capacity', label: 'Manual capacity', type: 'number' },
  { key: 'pallet_size', label: 'Pallet size', type: 'select', options: ['Standard', 'Large'], allowBlank: true },
  { key: 'notes', label: 'Notes', type: 'textarea' },
];

export const CAPACITY_PROFILE_FIELDS = [
  { key: 'max_units', type: 'number' },
  { key: 'max_cartons', type: 'number' },
  { key: 'units_per_carton', type: 'number' },
  { key: 'manual_capacity', type: 'checkbox' },
  { key: 'governance_status', type: 'select', options: ['READY FOR ERNIE APPROVAL', 'ERNIE DECISION REQUIRED', 'GOVERNANCE / DATA GAP'] },
  { key: 'notes', type: 'textarea' },
];

export const LOCATION_GROUP_FIELDS = [
  { key: 'pickable', type: 'checkbox' },
  { key: 'storage_form', type: 'text' },
  { key: 'lifecycle_state', type: 'text' },
  { key: 'normal_placement_eligible', type: 'text' },
  { key: 'governance_status', type: 'select', options: ['READY FOR ERNIE APPROVAL', 'ERNIE DECISION REQUIRED', 'GOVERNANCE / DATA GAP'] },
  { key: 'notes', type: 'textarea' },
];

const normalizeValue = (key, value) => {
  if (typeof value === 'boolean') return value;
  if (key === 'manual_capacity' && typeof value === 'string' && value !== '' && Number.isFinite(Number(value))) return Number(value);
  const numericKeys = new Set(['max_units', 'max_cartons', 'units_per_carton']);
  if (numericKeys.has(key)) return value === '' || value === null || value === undefined ? null : Number(value);
  return value;
};

const equalValues = (left, right) => (left === '' && (right === null || right === undefined))
  || (right === '' && (left === null || left === undefined))
  || left === right;

export const buildPatch = (before, form, reason) => {
  const patch = {};
  Object.keys(form).forEach((key) => {
    const value = normalizeValue(key, form[key]);
    const current = normalizeValue(key, before?.[key]);
    if (!equalValues(value, current)) patch[key] = value;
  });
  return { ...patch, reason };
};
